import MyAccountPage from '@/pages/compliance/MyAccountPage'

// 2.13.1 — Privacy & data (profile settings). Hosts the account deletion
// control and a link to the privacy policy.
export default function PrivacyDataPage() {
  return <MyAccountPage section='privacy' />
}
